import { Button } from "@/components/ui/button";
import { logout } from "@/utils/authentication";
import { SiMacos } from "react-icons/si";
import { FaWindows } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const ErrorFallback = () => {

  // Hooks
  const { t } = useTranslation();

  const handleLogout = async () => {
    await logout();
    location.replace("/login");
  };

  return (
    <div className="w-full h-[100vh] flex flex-col items-center justify-center select-none px-6">
      {/* Error content */}
      <div className="text-center flex flex-col items-center">
        <h1 className="text-4xl font-bold text-gray-700">{t("errorboundaryfallback.title")}</h1>
        <p className="text-lg text-gray-500 font-light mt-2">{t("errorboundaryfallback.description")}</p>
        <p className="text-lg text-gray-500 font-light mb-2">{t("errorboundaryfallback.translationinstruction")}</p>
        <p className="text-lg text-gray-500 font-light">
          {t("errorboundaryfallback.reloadinstruction")}
        </p>
        <p className="text-lg text-gray-500 font-light">
          {t("errorboundaryfallback.logoutinstruction")}
        </p>
        <div>
          <div className="flex items-center gap-2 text-gray-600">
            <p className="font-bold">Cmd + Shift + R</p>
            (<SiMacos className="icon-lg"/>)
          </div>
          <p className="font-light text-gray-600">
            {t("errorboundaryfallback.or")}
          </p>
          <div className="flex items-center gap-2 text-gray-600">
            <p className="font-bold">Ctrl + Shift + R</p>
            (<FaWindows className="icon-lg"/>)
          </div>
        </div>
        <div className="my-2">
          <Button onClick={handleLogout}>
            Logout
          </Button>
        </div>
        <p className="text-lg text-gray-500 font-light">
          {t("errorboundaryfallback.contact")}&nbsp;
          <a href="mailto:contact@wisebid.cloud" className="text-blue-400">
            contact@wisebid.cloud
          </a>
        </p>
      </div>
    </div>
  );
};

export default ErrorFallback;
